import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import { getUserFromSession } from './utils/auth';

// 批量搜索接口靠 UserEmail 识别管理员；子组件请求未传该参数会导致后端仍限 20 条
axios.interceptors.request.use((config) => {
  const user = getUserFromSession();
  if (!user) return config;
  const params = config.params || {};
  const hasSearch = params.search != null && String(params.search).trim() !== '';
  if (!hasSearch) return config;
  config.params = {
    ...params,
    UserEmail: params.UserEmail || user.email || '',
    username: params.username || user.username || '',
  };
  return config;
});

Vue.prototype.$axios = axios;

Vue.config.productionTip = false
if (typeof window !== 'undefined' && window.ELEMENT) {
  Vue.use(window.ELEMENT);
} else {
  console.warn('Element UI 未找到，请确认 public/index.html 中已通过 CDN 引入 Element UI');
}
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
